export const CLOUDFLARE_TRACE_URL = "https://cloudflare.com/cdn-cgi/trace";

export type CloudflareTrace = Record<string, string>;
export type CloudflareBlock = {
  status: number;
  statusText?: string;
  headers: Record<string, string>;
};

export type CloudflareTraceMetadata = {
  status?: number;
  error?: string;
  trace?: CloudflareTrace;
};

export const parseCloudflareTrace = (traceText: string): CloudflareTrace =>
  traceText.split("\n").reduce<CloudflareTrace>((trace, line) => {
    const separatorIndex = line.indexOf("=");
    if (separatorIndex <= 0) {
      return trace;
    }

    trace[line.slice(0, separatorIndex)] = line.slice(separatorIndex + 1);
    return trace;
  }, {});

export const getCloudflareBlock = (response: Response): CloudflareBlock => {
  const block: CloudflareBlock = {
    status: response.status,
    headers: {},
  };

  if (response.statusText) {
    block.statusText = response.statusText;
  }

  response.headers?.forEach((value, key) => {
    block.headers[key] = value;
  });

  return block;
};

export const getSupportReferenceId = (cloudflareBlock: CloudflareBlock): string | undefined => {
  const referenceId = cloudflareBlock.headers["cf-ray"] ?? cloudflareBlock.headers["cf-request-id"];
  return referenceId || undefined;
};

export const fetchCloudflareTrace = async (signal?: AbortSignal): Promise<CloudflareTraceMetadata> => {
  try {
    const response = await fetch(CLOUDFLARE_TRACE_URL, {
      cache: "no-store",
      method: "GET",
      signal,
    });

    return {
      status: response.status,
      trace: parseCloudflareTrace(await response.text()),
    };
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      return {};
    }

    return {
      error: error instanceof Error ? error.message : String(error),
    };
  }
};
